angular.module('iqxCore')
.service('actionDialogSvc', function (FormSvc) {
    var svc=this
    svc.show = function(scope, data){
        scope.actiondialogparams=data
        FormSvc.modalForm(scope,'actionDialog.html',data,'xl',true)
    }
})
